import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

import type { FiatCurrencyCode } from '@/constants/fiatCurrency';
import { DEFAULT_FIAT_CURRENCY } from '@/constants/fiatCurrency';

type FxRates = Partial<Record<FiatCurrencyCode, number>>;

interface CurrencyStore {
  selectedCurrency: FiatCurrencyCode;
  setSelectedCurrency: (currency: FiatCurrencyCode) => void;
  fxRates: FxRates;
  setFxRates: (rates: FxRates) => void;
}

export const useCurrencyStore = createWithEqualityFn<CurrencyStore>()(
  persist(
    (set) => ({
      selectedCurrency: DEFAULT_FIAT_CURRENCY,
      setSelectedCurrency: (selectedCurrency: FiatCurrencyCode) => set({ selectedCurrency }),
      fxRates: { USD: 1 },
      setFxRates: (fxRates: FxRates) => set({ fxRates: { USD: 1, ...fxRates } }),
    }),
    {
      name: 'currency-store',
      partialize: (state) => ({
        selectedCurrency: state.selectedCurrency,
      }),
    },
  ),
  shallow,
);

export const selectedCurrencySelector = (state: CurrencyStore) => state.selectedCurrency;
export const setSelectedCurrencySelector = (state: CurrencyStore) => state.setSelectedCurrency;
export const fxRatesSelector = (state: CurrencyStore) => state.fxRates;
export const setFxRatesSelector = (state: CurrencyStore) => state.setFxRates;
